<script setup>
import Button from "@/Components/Buttons/Button.vue";
</script>

<template>
    <Button class="bg-theme-primary text-white hover:brightness-90 transition-all duration-300">
        <slot />
    </Button>
</template>

<style scoped></style>
